export default __webpack_public_path__ + "static/media/fish.fde50a2a.png";